import { Fragment, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import NodeCategories, {
  EDataType,
  EDataSwitchType,
} from '../models/node-data';
import MenuNodeList from './MenuNodeList';

function MenuSwitches() {
  const [types, setTypes] = useState<EDataSwitchType[]>([]);
  const filters = Object.keys(NodeCategories).filter(
    (key) =>
      NodeCategories[key as keyof typeof NodeCategories].type ===
        EDataType.Switch &&
      !NodeCategories[key as keyof typeof NodeCategories].hidden,
  );

  const allSwitchTypes = [
    ...new Set(
      filters
        .map(
          (key) =>
            NodeCategories[key as keyof typeof NodeCategories].switchType,
        )
        .flat(),
    ),
  ];

  const filterLists = () => {
    if (types.length === 0) {
      return [];
    }
    return filters.filter((key) =>
      types?.every((item) =>
        NodeCategories[key as keyof typeof NodeCategories].switchType?.includes(
          item,
        ),
      ),
    );
  };

  const listKeys = filterLists();

  const allTypes = () => {
    const allKeys = listKeys.length === 0 ? filters : listKeys;
    const listTypes = allKeys
      .map(
        (key) => NodeCategories[key as keyof typeof NodeCategories].switchType,
      )
      .flat();

    return [...new Set(listTypes)];
  };

  return (
    <>
      <div className="flex w-full flex-row gap-2 bg-linear-gradient">
        <div className="flex w-full flex-row items-center justify-center gap-2 p-2">
          {Object.values(EDataSwitchType).map((key, i) => {
            if (!allSwitchTypes.includes(key))
              return <Fragment key={`type${i}`} />;
            return (
              <button
                key={`type${i}`}
                data-testid={`menu-switch-type-${key}`}
                type="button"
                className={twMerge([
                  'rounded border border-blue-400 bg-white px-2 py-2 text-sm font-semibold capitalize text-gray-900 shadow-sm ring-1 ring-inset ring-blue-400 hover:border-white hover:bg-blue-600 hover:text-white hover:ring-0',
                  'disabled:cursor-not-allowed disabled:border-gray-100 disabled:bg-gray-300 disabled:ring-gray-300',
                  types.includes(key)
                    ? 'border-white bg-blue-400 text-white ring-0'
                    : '',
                ])}
                disabled={!allTypes().includes(key)}
                onClick={() => {
                  if (types.includes(key)) {
                    setTypes((prev) => prev.filter((el: string) => el !== key));
                  } else {
                    setTypes((prev) => [...prev, key]);
                  }
                }}
              >
                {key.replace('-', ' ')}
              </button>
            );
          })}
        </div>
      </div>
      <h1 className="text-center text-2xl font-medium text-blue-400">
        ROQSTAR SWITCHES
      </h1>
      <MenuNodeList data-testid="menu-switches-list" data={listKeys} />
    </>
  );
}

export default MenuSwitches;
